import { auditReports } from '@mi-front/api-clients';
import { UserRole } from '@mi-front/core';
import { useIntl } from 'react-intl';
import { NavItemWithChildren } from '../../../components/layout/sidenav/link/NavItemWithChildren';
import { useHasPermission } from '../../../core/auth/authorization/hooks/useHasPermission';
import { useHasRole } from '../../../core/auth/authorization/hooks/useHasRole';
import { aodRoutes } from '../modules/aod/routing/routes';
import { AuditIcon } from './AuditIcon';

export function AuditLinks() {
  const { $t } = useIntl();

  const isAodManageEnabled = useHasPermission(auditReports.AuditReportsPermissions.AodRules_Manage);
  const isAodViewEnabled = useHasPermission(auditReports.AuditReportsPermissions.AodRules_View);
  const isAodEnabled = isAodManageEnabled || isAodViewEnabled;
  const isClientAdmin = useHasRole(UserRole.CLIENT_ADMIN);

  const children = [
    {
      label: $t({
        id: 'audit.sidenav.stationAudit',
        defaultMessage: 'Audit de emisora',
      }),
      to: '/audit',
      isActive: (pathname: string) => pathname.startsWith('/audit/s/'),
    },
    {
      label: $t({
        id: 'audit.sidenav.globalReports',
        defaultMessage: 'Audit global',
      }),
      to: '/audit/global-reports',
    },
    {
      to: `/audit/saved-reports`,
      label: $t({
        id: 'audit.reportsList.title',
        defaultMessage: 'Reportes guardados',
      }),
    },
  ];

  if (isAodEnabled) {
    children.push({
      label: $t({
        id: 'audit.sidenav.aod',
        defaultMessage: 'AOD',
      }),
      to: aodRoutes.root.gen(),
    });
  }

  if (isClientAdmin) {
    children.push({
      label: $t({
        id: 'audit.sidenav.config',
        defaultMessage: 'Config',
      }),
      to: '/audit/config',
    });
  }

  return (
    <NavItemWithChildren
      root="/audit"
      label={$t({
        id: 'audit.title',
        defaultMessage: 'Auditoría',
      })}
      icon={<AuditIcon />}
      items={children}
    />
  );
}
